export const REPORT_DESIGN = 'report_design'
export const WEB_APPLICATION = 'web_application'
export const SET_PDF = 'set_pdf'
